export function escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
export function highlightMatches(text: string, searchValue: string) {
    // Escape special regex characters in searchValue
    const escapedSearchValue = escapeRegExp(searchValue);

    return text
        .split(new RegExp(`(${escapedSearchValue})`, "i"))
        .map((part, index) =>
            part.toLowerCase() === searchValue.toLowerCase()
                ? `<em key=${index}>${part}</em>`
                : `<span key=${index}>${part}</span>`
        )
        .join("");
}
